module.exports = __webpack_public_path__ + "static/media/sopManager_arrow_down.f752d98f.svg";